import React from "react";
import PropTypes from "prop-types";

import { Row, Col } from "reactstrap";
import Slider from "rc-slider";
import Colors from "../../res/colors/colors";
import DateUtils from "../../inumet_js_lib/utils/dateUtils";
import ImgButton from "../buttons/imgButton";
import Periodicidad from "../../inumet_js_lib/model/tipos/periodicidad";

import "rc-slider/assets/index.css";
import { isMobile } from "react-device-detect";

class SpinnerFechasDatosVars extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            playing: false,
        };
        this.intervalPlayId = 0;

        this.onIFechaChange = this.onIFechaChange.bind(this);
        this.onStepBw = this.onStepBw.bind(this);
        this.onPlay = this.onPlay.bind(this);
        this.onStepFw = this.onStepFw.bind(this);
        this.playDateTime = this.playDateTime.bind(this);
    }

    onIFechaChange(e) {
        this.props.onIFechaChange(e);
    }

    onStepBw() {
        let newiFecha =
            this.props.iFecha > 0
                ? this.props.iFecha - 1
                : this.props.cantFechasVar - 1;
        this.onIFechaChange(newiFecha);
        this.setState({ playing: false });
    }

    onPlay() {
        this.setState((prevState) => {
            if (!prevState.playing)
                this.intervalPlayId = setInterval(
                    this.playDateTime,
                    this.props.playTime
                );
            else clearInterval(this.intervalPlayId);
            let newPlaying = !prevState.playing;
            return { playing: newPlaying };
        });
    }

    onStepFw() {
        let newiFecha =
            this.props.iFecha < this.props.cantFechasVar - 1
                ? this.props.iFecha + 1
                : 0;
        this.onIFechaChange(newiFecha);
        this.setState({ playing: false });
    }

    playDateTime() {
        let newiFecha =
            this.props.iFecha < this.props.cantFechasVar - 1
                ? this.props.iFecha + 1
                : 0;
        this.onIFechaChange(newiFecha);
    }

    render() {
        if (
            !this.props.loading &&
            this.props.iFecha !== undefined &&
            this.props.datosVars &&
            this.props.datosVars.fechas.length > 0 &&
            this.props.show
        ) {
            let variable = this.props.datosVars.variables.getById(
                this.props.idVariable
            );
            let currDateSel = DateUtils.parseDateLT(
                this.props.datosVars.getFecha(
                    this.props.datosVars.iVar(this.props.idVariable),
                    this.props.iFecha
                )
            );
            let textoAvanzaTiempo = "+1";
            let textoRetrocedeTiempo = "-1";

            if (variable.periodicidad === Periodicidad.hour) {
                textoAvanzaTiempo = "+1 Hora";
                textoRetrocedeTiempo = "-1 Hora";
            } else if (variable.periodicidad === Periodicidad.day) {
                currDateSel = DateUtils.addHours(currDateSel, 3);
                textoAvanzaTiempo = "+1 Día";
                textoRetrocedeTiempo = "-1 Día";
            }

            let arrayFechas = this.props.datosVars.getArrayStrFechasDeVar(
                variable.id
            );
            arrayFechas = arrayFechas.map((fecha) => {
                let fechaAux = DateUtils.parseDateLT(fecha);

                if (variable.periodicidad === Periodicidad.day)
                    fechaAux = DateUtils.addHours(fechaAux, 3);
                return Periodicidad.truncarAPeriodicidad(
                    fechaAux,
                    variable.periodicidad
                );
            });

            let marksSlider = {};
            let currDateLabel = (
                <h5
                    className="shadow-lg p-3"
                    style={{
                        background: "white",
                        padding: "8px",
                        borderRadius: "5px",
                    }}
                >
                    {variable.periodicidad === Periodicidad.day
                        ? DateUtils.latinD(currDateSel)
                        : DateUtils.latinDT(currDateSel)}
                </h5>
            );
            //marksSlider[this.props.iFecha]= currDateLabel;
            arrayFechas.forEach((f, i) => {
                marksSlider[i] = this.props.iFecha === i ? currDateLabel : "";
            });
            let sliderAlignment = "justify-content-left";
            let colsAlignment = "";
            if (isMobile) {
                sliderAlignment = "justify-content-center";
                colsAlignment = "text-center";
            }

            // let marks= ArrayUtils.arrayToObj(arrayFechas);
            return (
                <div
                    className="width-full ml-2 mt-2 mb-2"
                    style={{
                        position: "relative",
                        top: "0px",
                        left: "0px",
                        zIndex: 100,
                    }}
                >
                    <div style={{ background: "#d9e0e7" }}>
                        <Row className={"p-3 " + sliderAlignment}>
                            <Col
                                xs="auto"
                                sm="auto"
                                md="auto"
                                lg="auto"
                                className={colsAlignment}
                            >
                                <ImgButton
                                    iconId="backward"
                                    text={textoRetrocedeTiempo}
                                    onClick={this.onStepBw}
                                    mr={2}
                                />
                                <ImgButton
                                    iconId={
                                        this.state.playing
                                            ? "pause-circle"
                                            : "play-circle"
                                    }
                                    onClick={this.onPlay}
                                />
                                <ImgButton
                                    iconId="forward"
                                    iconAtEnd={true}
                                    text={textoAvanzaTiempo}
                                    onClick={this.onStepFw}
                                    ml={2}
                                />
                            </Col>

                            <Col
                                xs="10"
                                sm="10"
                                md="8"
                                lg="8"
                                className={"mt-2 " + colsAlignment}
                            >
                                <Slider
                                    dots={true}
                                    railStyle={{
                                        backgroundColor: Colors.primary,
                                        color: Colors.primary,
                                    }}
                                    dotStyle={{
                                        backgroundColor: Colors.primary,
                                        color: Colors.primary,
                                    }}
                                    marks={marksSlider}
                                    onChange={this.onIFechaChange}
                                    className="ml-2"
                                    style={{ width: "100%" }}
                                    min={0}
                                    max={arrayFechas.length - 1}
                                    value={this.props.iFecha}
                                    defaultValue={0}
                                    step={1}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        }
        return null;
    }
}

SpinnerFechasDatosVars.propTypes = {
    iFecha: PropTypes.number,
    datosVars: PropTypes.object,
    idVariable: PropTypes.number,
    playTime: PropTypes.number,
    cantFechasVar: PropTypes.number,
    onIFechaChange: PropTypes.func,
    loading: PropTypes.bool,
    show: PropTypes.bool,
};

export { SpinnerFechasDatosVars as default };
